"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sideDialogBaseStyles = void 0;
var sideDialogBaseStyles = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({
        title: {
            // Faking the border to stop it from bleeding all the way to the sides
            background: "bottom center / calc(100% - " + spacing(24) + "px) 1px no-repeat linear-gradient(" + palette.divider + ", " + palette.divider + ")",
        },
        content: {
            "&:last-child": {
                paddingBottom: spacing(8),
            },
        },
        actions: {
            justifyContent: "stretch",
            paddingBottom: spacing(8),
            "& > [class*='MuiButton-root']": {
                flexGrow: 1,
                flexBasis: 0,
            },
        },
    });
};
exports.sideDialogBaseStyles = sideDialogBaseStyles;
//# sourceMappingURL=sideDialogBaseStyles.js.map